// src/components/RightPanel/RightPanel.js
import React from 'react';
import NavBar from './NavBar';
import ContentArea from './ContentArea';
import CommandBar from './CommandBar';
import RightFooter from './RightFooter';
import ContentSwitcher from './ContentSwitcher';

const RightPanel = () => {
  return (
    <div className="flex flex-col h-full">
      <div className="sticky top-0">
        <NavBar />
        <ContentSwitcher /> {/* Added ContentSwitcher here */}
      </div>
      <div className="flex-grow overflow-y-auto">
        <ContentArea />
      </div>
      <div className="sticky bottom-0">
        <CommandBar />
        <RightFooter />
      </div>
    </div>
  );
};

export default RightPanel;
